import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faGoogle,
  faInstagram,
  faLine,
  faTelegram,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import myImage from '../images/bkam.webp';

const socialLinks = [
  {
    href: 'https://wa.me/+66641831185',
    label: 'WhatsApp',
    icon: faWhatsapp,
    className: 'text-green-500',
  },
  {
    href: 'https://line.me/R/ti/p/%40886yoeiq',
    label: 'Line',
    icon: faLine,
    className: 'text-green-600',
  },
  {
    href: 'https://www.facebook.com/profile.php?id=100094543849028',
    label: 'Facebook',
    icon: faFacebook,
    className: 'text-blue-600',
  },
  {
    href: 'https://www.instagram.com/amonthanat_massage',
    label: 'Instagram',
    icon: faInstagram,
    className: 'text-pink-500',
  },
  {
    href: 'https://t.me/+66641831185',
    label: 'Telegram',
    icon: faTelegram,
    className: 'text-sky-500',
  },
  {
    href: 'https://www.google.com/maps/place/Amonthanat+Massage/@7.9029261,98.3465686,15.83z/data=!4m6!3m5!1s0x305031af2ee373f5:0xb44d9e232635a261!8m2!3d7.89823!4d98.355965!16s%2Fg%2F11kr5xp2b2?entry=ttu',
    label: 'Google Reviews',
    icon: faGoogle,
    className: 'text-amber-500',
  },
];

const Footer = () => {
  return (
    <footer className="px-4 pb-8 pt-10 md:px-6">
      <div className="mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-stone-950 via-stone-900 to-amber-950 text-white shadow-2xl shadow-stone-900/20">
        <div className="grid gap-10 px-8 py-10 md:px-10 lg:grid-cols-[1.1fr_0.9fr] lg:px-12">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-stone-300">
              Stay Connected
            </p>
            <h2 className="mt-4 font-cyclin text-4xl font-bold md:text-5xl">
              Amonthanat Massage
            </h2>
            <p className="mt-4 max-w-2xl text-lg leading-8 text-stone-200">
              Direct booking, daily opening hours and easy access in Kathu,
              Phuket. Contact us on your preferred channel.
            </p>

            <div className="mt-6 flex flex-wrap gap-3 text-sm font-semibold text-stone-100">
              <a
                href="tel:+66641831185"
                className="rounded-full border border-stone-600 px-4 py-2 transition hover:-translate-y-0.5 hover:border-stone-400"
              >
                Call: +66 64 183 1185
              </a>
              <a
                href="https://www.google.com/maps/place/Amonthanat+Massage/@7.9029261,98.3465686,15.83z/data=!4m6!3m5!1s0x305031af2ee373f5:0xb44d9e232635a261!8m2!3d7.89823!4d98.355965!16s%2Fg%2F11kr5xp2b2?entry=ttu"
                target="_blank"
                rel="noreferrer"
                className="rounded-full border border-stone-600 px-4 py-2 transition hover:-translate-y-0.5 hover:border-stone-400"
              >
                See Google Reviews
              </a>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              {socialLinks.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={item.label}
                  className={`flex h-12 w-12 items-center justify-center rounded-full border border-stone-600 bg-stone-900/80 transition hover:-translate-y-0.5 hover:border-stone-400 hover:bg-stone-800 ${item.className}`}
                >
                  <FontAwesomeIcon icon={item.icon} />
                </a>
              ))}
            </div>

            <div className="mt-8 space-y-2 text-sm font-medium text-stone-300">
              <p>19/8, Soi Bae Hoa, Kathu, Phuket 83120, Thailand</p>
              <p>Open every day from 9:00 AM to 9:00 PM</p>
              <p>Phone: +66 64 183 1185</p>
            </div>
          </div>

          <div className="rounded-[2rem] border border-stone-700/70 bg-gradient-to-br from-stone-900/70 to-amber-950/40 p-6">
            <div className="mx-auto max-w-xs overflow-hidden rounded-[1.75rem] border border-stone-700/70 bg-white/92 p-4 shadow-xl shadow-black/10">
              <img
                src={myImage}
                alt="Amonthanat Massage"
                className="h-56 w-full rounded-[1.25rem] object-cover"
              />
            </div>

            <div className="mt-6 text-center lg:text-left">
              <p className="text-sm font-semibold uppercase tracking-[0.28em] text-stone-300">
                Quick Links
              </p>
              <div className="mt-4 flex flex-col gap-3 text-lg">
                <a href="#our-massages" className="text-stone-100 transition hover:text-white">
                  Massages
                </a>
                <a href="#find-us" className="text-stone-100 transition hover:text-white">
                  Find Us
                </a>
                <a
                  href="https://wa.me/+66641831185"
                  target="_blank"
                  rel="noreferrer"
                  className="text-stone-100 transition hover:text-white"
                >
                  Book on WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-stone-700/60 px-8 py-5 text-center text-sm font-medium text-stone-300 md:px-10 lg:px-12">
          Copyright © {new Date().getFullYear()} Amonthanat Massage. All rights reserved. Developed by{' '}
          <a
            href="https://www.jr-ai-consulting.com"
            target="_blank"
            rel="noreferrer"
            className="text-stone-100 transition hover:text-white"
          >
            JR-AI-Consulting
          </a>
          .
        </div>
      </div>
    </footer>
  );
};

export default Footer;
